import { Environment } from "@citychallenge/common";
import { useMemo } from "react";

interface BlessedHTMLVideoElement extends HTMLVideoElement {
  hiddenContainer?: HTMLDivElement;
  videoJSWrapper?: HTMLDivElement;
}

declare global {
  interface Window {
    __BLESSED_VIDEO_ELEMENT?: BlessedHTMLVideoElement;
  }
}

export function loadBlessedVideoElement(): BlessedHTMLVideoElement {
  if (window.__BLESSED_VIDEO_ELEMENT) return window.__BLESSED_VIDEO_ELEMENT;

  const video: BlessedHTMLVideoElement = document.createElement("video");

  video.crossOrigin = "anonymous";
  video.preload = "auto";
  video.playsInline = true;

  if (Environment.OS !== "builder") {
    window.__BLESSED_VIDEO_ELEMENT = video;

    const hiddenContainer = document.createElement("div");
    document.body.appendChild(hiddenContainer);

    hiddenContainer.style.display = "none";
    video.hiddenContainer = hiddenContainer;
  }

  return video;
}

export function useBlessedVideoElement() {
  const blessedElement = useMemo(() => loadBlessedVideoElement(), []);

  return {
    video: blessedElement,
    /**
     * Claim this video element so that the parent and self is removed from
     * other locations in the dom
     */
    claim: () => {
      if (blessedElement.videoJSWrapper)
        blessedElement.hiddenContainer?.appendChild(
          blessedElement.videoJSWrapper
        );
    },
  };
}
